import React, { useEffect } from 'react';

function FormularioContactoPvcRigido() {
  useEffect(() => {
    // Carga el script de HubSpot
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.onload = () => {
      // Inicializa el formulario de HubSpot
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '47654427',
          formId: 'd84aaa61-130b-4771-a9da-25375d5da5a2',
          target: '#hubspotForm',
        });
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <section id="contacto" className="bg-light"> {/* Agregamos id="contacto" */}
      <div className="container">
        <div className="title-style2 text-center mb-2-2">
          <h2 className="h1">¡Contáctanos para más información del Piso de PVC y una cotización personalizada!</h2>
        </div>
        <div className="row">
          <div 
            className="col-lg-8 mb-5 mb-lg-0 mb-md-5 mx-auto wow fadeIn" 
            data-wow-delay="400ms"
          >
            <div className="contact-form p-4 p-md-5 bg-white rounded">
              <form className="quform">
                {/* Aquí se insertará el formulario de HubSpot */}
                <div id="hubspotForm"></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FormularioContactoPvcRigido;